package net.dipgo.game

import kotlin.math.absoluteValue
import kotlin.math.roundToInt
import kotlin.math.roundToLong

data class TeamScore(val points: Int, val komi: Double, val captures: Int) {
    fun totalTeamScore(): Double {
        return this.points + this.captures + this.komi
    }

    fun scoreDisplayString(): String {
        val totalPoints = totalTeamScore()

        val totalPointsRoundedIfInt = if (totalPoints.toString().takeLast(2) == ".0") {
            totalPoints.roundToInt()
        } else {
            formatOneDecimal(totalPoints)
        }

        val displayString =
            "$totalPointsRoundedIfInt point"
        return if (totalPoints == 1.0) {
            displayString
        } else {
            displayString + "s"
        }
    }

    fun scoreBreakdownString(capturesOn: Boolean): String {
        val stringBuilder = StringBuilder("$points area")
        if (capturesOn) {
            stringBuilder.append(""" + $captures capture""")
            if (captures != 1) {
                stringBuilder.append("s")
            }
        }
        if (komi != 0.0) {
            if (komi > 0) {
                stringBuilder.append(" + $komi komi")
            } else {
                stringBuilder.append(" - ${komi.absoluteValue} komi")
            }
        }

        return if (scoreCanBeBrokenDown(capturesOn)) {
            stringBuilder.toString()
        } else {
            ""
        }
    }

    private fun scoreCanBeBrokenDown(capturesOn: Boolean) = capturesOn || this.komi != 0.0

    private fun formatOneDecimal(value: Double): String {
        val tenths = (value * 10).roundToLong()
        val whole = tenths / 10
        val frac = (tenths % 10).let { if (it < 0) -it else it }
        return if (tenths < 0 && whole == 0L) "-0.$frac" else "$whole.$frac"
    }
}
